import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const links = [
    { name: "Features", href: "features", type: "section" },
    { name: "About", href: "about", type: "section" },
    { name: "Services", href: "services", type: "section" },
    { name: "Tools", href: "portfolio", type: "section" },
    { name: "Team", href: "team", type: "section" },
    { name: "Contact", href: "contact", type: "section" },
  ];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const handleLinkClick = (link) => (e) => {
    closeMenu();

    if (link.type === "section") {
      e.preventDefault();

      // אם אנחנו לא בדף הבית, קודם ננווט לשם
      if (location.pathname !== "/") {
        navigate("/", { replace: false });
        setTimeout(() => {
          const el = document.getElementById(link.href);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      } else {
        const el = document.getElementById(link.href);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <nav
      ref={menuRef}
      id="menu"
      className="navbar navbar-default navbar-fixed-top"
      style={{
        transition: "all 0.4s ease",
        backgroundColor: scrolled ? "rgba(15,75,86,0.95)" : "rgba(15,75,86,0.5)",
        boxShadow: scrolled ? "0 2px 10px rgba(0,0,0,0.15)" : "none",
        border: "none",
      }}
    >
      <div className="container">
        <div className="navbar-header navbar-right">
          <button
            type="button"
            className={`navbar-toggle ${menuOpen ? "" : "collapsed"}`}
            onClick={toggleMenu}
            style={{ borderColor: "transparent" }}
          >
            <span className="sr-only">החלף ניווט</span>
            <span className="icon-bar" style={{ backgroundColor: "#fff" }}></span>
            <span className="icon-bar" style={{ backgroundColor: "#fff" }}></span>
            <span className="icon-bar" style={{ backgroundColor: "#fff" }}></span>
          </button>

          <a
            className="navbar-brand page-scroll"
            href="#header"
            onClick={(e) => {
              e.preventDefault();
              const el = document.getElementById("header");
              if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              closeMenu();
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "-25px",
                transition: "all 0.3s ease",
                transform: scrolled ? "scale(0.85)" : "scale(1)",
              }}
            >
              <img
                src="img/logos/drbroker.png"
                alt="Logo"
                style={{
                  height: "70px",
                  marginLeft: "10px",
                  borderRadius: "10px",
                  transition: "all 0.3s ease",
                }}
              />
            </span>
          </a>
        </div>

        <div
          className={`collapse navbar-collapse navbar-left ${menuOpen ? "in" : ""}`}
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav">
            {links.map((link) => (
              <li key={link.href}>
                {link.type === "section" ? (
                  <a
                    href={`#${link.href}`}
                    className="page-scroll"
                    style={{
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                      color: "#fff",
                    }}
                    onClick={handleLinkClick(link)}
                    onMouseEnter={(e) => (e.target.style.color = "rgba(0,0,0,0.95)")}
                    onMouseLeave={(e) => (e.target.style.color = "#fff")}
                  >
                    {link.name}
                  </a>
                ) : (
                  <a
                    href={link.href}
                    style={{
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                      color: "#fff",
                    }}
                    onClick={handleLinkClick(link)}
                    onMouseEnter={(e) => (e.target.style.color = "rgba(0,0,0,0.95)")}
                    onMouseLeave={(e) => (e.target.style.color = "#fff")}
                  >
                    {link.name}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};
